import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var companyHome = {
  // 菜单列表
  showMenu(params) {
    return http.post(`${baseUrl}Role/showMenu`, params)
  },
  // 获取账户数据图数据
  getStatistics(params) {
    return http.post(`${baseUrl}Company/monthly_statistics_order_quantity`, params)
  },
  // 获取发票概况
  getOpenService(params) {
    return http.post(`${baseUrl}User/getOpenService`, params)
  },
  // 获取账户概况
  getCompanyBank(params) {
    return http.post(`${baseUrl}Company/companyBank`, params)
  },
}



// WEBPACK FOOTER //
// ./src/api/companyHome.js